import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { DatasetListingService } from 'src/app/dataset-listing/dataset-listing.service';
import { TreeGeneratorService } from 'src/app/core/datasets/tree-generator.service';
import { Subscription } from 'rxjs';
import { ITreeNode } from 'src/app/core/datasets/tree.interface';
import { AdminService } from '../admin/admin.service';
import { MatDialog } from '@angular/material/dialog';
import { ImportDatasetFileDialogComponent } from './import-dataset-dialog/import-dataset-dialog.component';
import { ActivatedRoute, Router } from '@angular/router';
import { TopBarService } from 'src/app/top-bar/top-bar.service';

@Component({
  selector: 'mood-covariates-admin',
  templateUrl: './covariates.component.html',
  styleUrls: ['covariates.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CovariatesAdminComponent implements OnInit, OnDestroy {
  selectedCovariateId?: string;

  covariateList: ITreeNode[] = [];

  datasetClickedString: EventEmitter<string> = new EventEmitter<string>();
  private _datasetClickedSubscription?: Subscription;
  private _datasetCategoryChangeSubscription?: Subscription;

  constructor(private _dataListService: DatasetListingService,
    private _treeGenerator: TreeGeneratorService,
    private _adminService: AdminService,
    private _changeDetector: ChangeDetectorRef,
    private _dialog: MatDialog,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _topBarService: TopBarService,
  )
  {
    this._topBarService.setTitle('Covariate Datasets');
  }

  ngOnDestroy(): void {
    this._datasetClickedSubscription?.unsubscribe();
    this._datasetCategoryChangeSubscription?.unsubscribe();
  }

  async ngOnInit() {
    await this._generateTree();

    this._datasetClickedSubscription = this.datasetClickedString.subscribe(dataset_id => {
      this._router.navigate(
        [],
        {
          relativeTo: this._activatedRoute,
          queryParams: {
            id: dataset_id
          }
        }
      );
    });

    this._datasetCategoryChangeSubscription = this._adminService.datasetCategoryUpdated.subscribe(async _ => {
      await this._generateTree();
    })

    this._activatedRoute.queryParams.subscribe(params => {
      this.selectedCovariateId = params['id'];
      this._changeDetector.markForCheck();
    });
  }

  private async _generateTree() {
    const covariateDatasets = await this._dataListService.getDatasetListing();
    const categories = await this._dataListService.getDatasetCategories();

    this.covariateList = this._treeGenerator.constructTreeFromCategories(covariateDatasets, categories);

    this._changeDetector.markForCheck();
  }

  openDatasetImportDialog() {
    let dialogRef = this._dialog.open(ImportDatasetFileDialogComponent,
      {
        width: '800px',
        maxWidth: '800px'
      });

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        await this._generateTree();
        this.datasetClickedString.emit(result)
      }
    });
  }
}
